import { render, staticRenderFns } from "./MyProgramNavigation.vue?vue&type=template&id=5f9c3423&scoped=true"
import script from "./MyProgramNavigation.vue?vue&type=script&lang=ts"
export * from "./MyProgramNavigation.vue?vue&type=script&lang=ts"
import style0 from "./MyProgramNavigation.vue?vue&type=style&index=0&id=5f9c3423&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c3423",
  null
  
)

export default component.exports